( function( $ ) {
    $( document ).ready( function() {

        var headerHeight = $('.header-container').outerHeight() + 20; //20px spacing between header and div

        // smooth scrolling
        // Select all links with hashes
        $('a[href*="#"]')
            // Remove links that don't actually link to anything or should not trigger
            .not('[href="#"]')
            .not('[href^="#collapse"]') //faq page
            .not('[href="#0"]')
            .not('[href="#single-product-carousel"]')
            .not('.msp-no-smooth-scroll')
            .on('click', function(event) {

                // On-page links
                if (
                    location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
                    location.hostname === this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $(this.hash);

                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top - headerHeight
                        }, 0, function() {
                            // Callback after animation
                            // Must change focus!
                            var $target = $(target);
                            $target.trigger('focus');
                            if ($target.is(":focus")) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                                $target.trigger('focus'); // Set focus again
                            }
                        });
                    }
                }
            });

        if (window.location.hash) {

            let hash = window.location.hash; //this.getAttribute('href');
            let target = document.querySelector(hash);
            let elementPosition = target.offsetTop;
            let offsetPosition = elementPosition - headerHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });


            /*var target = $(window.location.hash);

            $('html, body').animate({
                scrollTop: target.offset().top - headerHeight
            }, 1000, function() {
                // Callback after animation
                // Must change focus!
                //var $target = $(target);
                target.trigger('focus');
                if (target.is(":focus")) { // Checking if the target was focused
                    return false;
                } else {
                    target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                    target.trigger('focus'); // Set focus again
                }
            });*/
        }
    });
})(jQuery);